
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ContentHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    tag: {
      type: String,
      required: true
    }
  },
  setup(props) {
    return {
      props
    };
  }
});
